<div class="row">
	<div class="col-md-6 offset-md-3">
		<div class="card">
			<div class="card-body">
				<h4 class="card-title mb-5 text-center">Changer mon mot de passe</h4>

				<form [formGroup]="changePasswordForm" class="form-signin">
					<div class="form-row container">
						<div class="col-sm-12">
							<app-valid-input
								[inputType]="'password'"
								[control]="
									convertToFormControl(
										changePasswordForm.get('currentPassword')
									)
								"
								[placeHolder]="'Mot de passe actuel'"
							></app-valid-input>
							<app-valid-input
								[inputType]="'password'"
								[control]="
									convertToFormControl(changePasswordForm.get('newPassword'))
								"
								[placeHolder]="'Nouveau mot de passe'"
							></app-valid-input>
							<app-valid-input
								[inputType]="'password'"
								[control]="
									convertToFormControl(
										changePasswordForm.get('newPasswordRepeated')
									)
								"
								[placeHolder]="'Répéter le nouveau'"
							></app-valid-input>
							<div
								*ngIf="isFormError()"
								class="alert alert-danger"
								role="alert"
							>
								<p *ngIf="changePasswordForm.errors.noMatchingPassword">
									Les mots de passe ne sont pas identiques
								</p>
							</div>
							<div class="row">
								<div class="col d-flex justify-content-end">
									<button
										class="btn theme-green-button ml-2"
										(click)="changePassword()"
										[disabled]="changePasswordForm.invalid"
									>
										Valider
									</button>
								</div>
							</div>
						</div>
					</div>
				</form>

				<div
					class="alert alert-success alert-dismissible fade show"
					role="alert"
					*ngIf="successfulChange"
				>
					<button
						type="button"
						class="close"
						data-dismiss="alert"
						aria-label="Close"
						(click)="closeAlerts()"
					>
						<span aria-hidden="true">&times;</span>
					</button>
					Mot de passe modifié avec succès !
				</div>
				<div
					class="alert alert-danger alert-dismissible fade show"
					role="alert"
					*ngIf="unsuccessfulChange"
				>
					<button
						type="button"
						class="close"
						data-dismiss="alert"
						aria-label="Close"
						(click)="closeAlerts()"
					>
						<span aria-hidden="true">&times;</span>
					</button>
					Mot de passe non modifié : une erreur est survenue. Si l'erreur
					persiste, veuillez prendre contact avec un administrateur.
				</div>
			</div>
		</div>
	</div>
</div>
